import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const CallToAction = () => {
  return (
    <section className="py-20 bg-slate-900 text-white relative overflow-hidden">
      {/* Abstract background */}
      <div className="absolute inset-0 opacity-10">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0,0 L100,0 L100,100 L0,100 Z" fill="url(#grid)" />
        </svg>
        <defs>
          <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
        </defs>
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Bereit für den nächsten Schritt?
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
            Egal ob du Geld dazuverdienen möchtest oder Personal für dein Geschäft suchst – wir machen es einfach.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/bewerber" className="bg-teal-500 text-white px-8 py-4 rounded-md text-lg font-medium hover:bg-teal-400 transition-colors shadow-lg shadow-teal-500/30 flex items-center justify-center group">
              Ich suche einen Nebenjob
              <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/unternehmen" className="bg-white text-slate-900 px-8 py-4 rounded-md text-lg font-medium hover:bg-slate-100 transition-colors flex items-center justify-center group">
              Ich suche Personal
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;